import * as React from 'react';
import {default as SendIcon} from '@material-ui/icons/Send';
import {connect} from 'react-redux';
import {IFamilyMember} from '@app-types/websocket/family.types';
import {IconButton as IconButtonMUI, Menu, MenuItem, WithStyles, withStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import {imageFlowStyle} from './imageflow.style';
import {default as LoveBorderIcon} from '@material-ui/icons/FavoriteBorder';
import {default as LoveIcon} from '@material-ui/icons/Favorite';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import {ICreateFlowPostComment, IFlowPost, ILikeFlowPost, ISeenFlowPost} from '@app-types/websocket/imageflow.types';
import * as ImageFlowActions from '@services/imageflow/imageflow.actions';
import {MoreVert} from "@material-ui/icons";
import IconButton from "@components/common/iconButton/iconButton.component";

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof imageFlowStyle> {
  family: IFamilyMember[];
  user: IFamilyMember | undefined;
  post: IFlowPost;
  scrollTime: number;

  comment: (data: ICreateFlowPostComment) => void;
  like: (data: ILikeFlowPost) => void;
  seen: (data: ISeenFlowPost) => void;
  delete: (postId: number) => void;
}

interface IState {
  newComment: string;
  newLike: boolean;
  hasFocus: boolean;
  openMenu: boolean;
  seenCalled: boolean;
}

class ImageFlowPost extends React.Component<IProps, IState> {
  private timer: NodeJS.Timeout | undefined;
  private buttonRef: React.RefObject<HTMLButtonElement>;
  private myRef: HTMLDivElement | null = null;

  constructor(props: IProps) {
    super(props);
    this.state = {
      newComment: "",
      newLike: false,
      hasFocus: false,
      openMenu: false,
      seenCalled: false,
    };

    this.buttonRef = React.createRef();
  }

  public componentDidMount() {
    if (this.state.seenCalled === false
      && this.props.user
      && this.props.post.seen.indexOf(this.props.user.id) === -1) {
      if (this.isInViewport()) {
        this.setState({seenCalled: true});
        this.props.seen({postId: this.props.post.postId});
      }
    }
  }

  public componentDidUpdate(oldProps: Readonly<IProps>): void {
    if (this.state.seenCalled === false
      && this.props.user
      && this.props.post.seen.indexOf(this.props.user.id) === -1
      && oldProps.scrollTime !== this.props.scrollTime) {
      if (this.isInViewport()) {
        this.setState({seenCalled: true});
        this.props.seen({postId: this.props.post.postId});
      }
    }
  }

  public render() {
    const {classes} = this.props;

    const style: any = {width: 16, height: 16, marginRight: 2, border: '1px solid transparent'};
    const poster = this.props.family.find((mem) => mem.id === this.props.post.senderId);
    if (poster === undefined || this.props.user === undefined) return (<div className={classes.card}/>);
    const seenBy: JSX.Element | null =
      <div className={classes.seenBy}>
        {tn.lang.todoSeenBy}
        {this.getSeenAvatar(this.props.post.seen)}
      </div>;

    return (
      <div
        className={classes.card}
        ref={(el) => this.myRef = el}
        style={(this.props.user && this.props.post.seen.indexOf(this.props.user.id) === -1) ? {boxShadow: "0px 3px 30px rgb(255 50 50 / 30%)"} : {}}
      >
        <div className={classes.cardTop}>
          <ImgAvatar altText={poster.firstName} color={poster.color} imgName={poster.avatar}
            imgUrl={poster.imageAvatar?poster.avatarURL:undefined} style={{width: '36px', height: '36px', borderRadius: '120px'}}/>
          <div className={classes.topMiddle}>
            <span className={classes.name}>{poster.firstName}</span>
            <span className={classes.date}>{tn.formatDateDayMonthYear(new Date(this.props.post.sendingTime))}</span>
          </div>
          <IconButtonMUI
            className={classes.moreOptionsButton}
            ref={this.buttonRef}
            id={"flowpostb" + this.props.post.postId}
            onClick={() => this.setState({openMenu: true})}
            aria-controls={this.state.openMenu ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
          >
            <MoreVert fontSize="inherit"/>
          </IconButtonMUI>
          <Menu
            id={"post-menu" + this.props.post.postId}
            anchorEl={this.buttonRef.current}
            open={this.state.openMenu}
            onClose={() => this.setState({openMenu: false})}
            MenuListProps={{
              'aria-labelledby': ("flowpostb" + this.props.post.postId),
            }}
            getContentAnchorEl={null}
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            transformOrigin={{vertical: 'top', horizontal: 'center'}}
            classes={{
              paper: classes.menuPaper,
              list: classes.menuList,
            }}
          >
            <MenuItem
              className={classes.menuListItem}
              disabled={(this.props.post.senderId !== this.props.user.id)}
              onClick={() => {
                this.setState({openMenu: false});
                this.props.delete(this.props.post.postId);
              }}>
              {tn.lang.delete}
            </MenuItem>
            <MenuItem onClick={() => {
              this.setState({openMenu:false});
            }}>
              <a href={this.props.post.fileDesc.url} className={classes.downloadLink} target="_blank" rel="noopener noreferrer">
              {tn.lang.download}
              </a>
            </MenuItem> 
          </Menu>
        </div>
        <div className={classes.postImg}
             onClick={() => {
               this.setState({newLike: true});
               this.props.like({like: true, postId: this.props.post.postId});
               if (this.timer) {
                 clearTimeout(this.timer);
               }
               this.timer = setTimeout(() => this.setState({newLike: false}), 2000);
             }}
             style={{backgroundImage: "url(\"" + this.props.post.fileDesc.url + "\")"}}>
          <LoveIcon className={classes.centerHeart} style={this.state.newLike ? {opacity: 1} : {}}/>
        </div>
        <div className={classes.column}>
          <div className={classes.row}>
            {(this.props.post.likes.indexOf(this.props.user.id) > -1
              ? <LoveIcon style={{fill: '#f65a55'}} onClick={() => this.props.like({like: false, postId: this.props.post.postId})}/>
              : <LoveBorderIcon onClick={() => this.props.like({like: true, postId: this.props.post.postId})}/>)}
            <div className={classes.avatars}>
              {this.getAvatars(this.props.post.likes)}
            </div>
          </div>
          {this.props.post.comments && this.props.post.comments[0] && (
            <div className={classes.row}>
              {this.props.post.comments[0].commentId > 0 || this.props.post.comments[0].senderId !== this.props.post.senderId
                ? this.getAvatar(this.props.post.comments[0].senderId)
                : null}
              {this.props.post.comments[0].msg}
            </div>
          )}
        </div>
        <div className={classes.column}>
          {this.props.post.comments.slice(1)?.map((comment, index) =>
            <div key={index} className={classes.row}>
              {comment.commentId > 0 || comment.senderId !== this.props.post.senderId
                ? this.getAvatar(comment.senderId)
                : null}
              {comment.msg}
            </div>
          )}
          <div className={classes.row}>
            <ImgAvatar color={this.props.user.color} imgName={this.props.user.avatar} style={style}
              imgUrl={this.props.user.imageAvatar?this.props.user.avatarURL:undefined} altText={this.props.user.firstName}/>
            <input 
              type="text"
              value={this.state.newComment}
              onChange={(event) => this.setState({newComment: event.target.value})}
              className={classes.editComment}
              autoCorrect="on"
              spellCheck={true}
              autoComplete="off"
              onFocus={() => this.setState({hasFocus: true})}
              onBlur={() => this.setState({hasFocus: false})}
              onKeyDown={this.handleKeyPress}
              maxLength={1024}
              placeholder={tn.lang.flowPostSddComment}/>
            <IconButton
              className={classes.sendButton}
              style={!(this.state.hasFocus || this.state.newComment.length > 0) ? {
                opacity: 0,
                pointerEvents: 'none',
              } : {}}
              onClick={() => {
                this.props.comment({postId: this.props.post.postId, msg: this.state.newComment});
                this.setState({newComment: "", hasFocus: false});
              }}
            >
              <SendIcon fontSize="inherit" color="secondary" />
            </IconButton>
          </div>
        </div>
        <div className={classes.cardBottom}>
          {seenBy}
        </div>
      </div>);
  }

  private handleKeyPress = (event: any) => {
    const {key, ctrlKey} = event;
    if (ctrlKey && key === 'Enter') {
      this.props.comment({postId: this.props.post.postId, msg: this.state.newComment});
      this.setState({newComment: "", hasFocus: false});
    }
  };

  private isInViewport(offset = 0) {
    if (!this.myRef) {
      return false;
    }
    const rect = this.myRef.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);

    // console.log(rect.top +" /" +viewHeight);

    if (!(rect.left >= 0 && rect.right <= viewWidth)) {
      return false;
    }
    if (!(rect.top >= 0 && (rect.top + 50) <= viewHeight)) {
      return false;
    } // if 50 pixels has been seen thats enough

    return true;
  }

  private getAvatar(accountId: number) {
    let image = 0;
    let name = "";
    let color = "#ffffff";
    let avatarUrl;

    for (const member of this.props.family) {
      if (member.id === accountId) {
        image = member.avatar;
        name = member.firstName;
        color = member.color;
        avatarUrl = member.imageAvatar?member.avatarURL:undefined
        break;
      }
    }
    const style: any = {width: 16, height: 16, marginRight: 2, border: '1px solid transparent'};
    return (<ImgAvatar color={color} imgName={image} style={style} altText={name} imgUrl={avatarUrl}/>);
  }


  private getSeenAvatar(accounts: number[]) {
    return accounts.map(accountId => {
      const member = this.props.family.find(m => m.id === accountId);
      if (member) {
        return (
          <ImgAvatar
            key={accountId}
            color={member.color || '#FFFFFF'}
            imgName={member.avatar}
            imgUrl={member.imageAvatar?member.avatarURL:undefined}
            style={{
              width: 10,
              height: 10,
            }}
            altText={member.firstName}
          />
        );
      }
      return null;
    });
  }

  private getAvatars(accounts: number[]) {
    let image = 0;
    let name = "";
    let color = "#ffffff";
    let imageUrl;
    const avatars: JSX.Element[] = [];

    let index = 0;
    for (const accountId of accounts) {
      for (const member of this.props.family) {
        if (member.id === accountId) {
          image = member.avatar;
          name = member.firstName;
          color = member.color;
          imageUrl = member.imageAvatar?member.avatarURL:undefined;
          break;
        }
      }
      const style: any = {width: 16, height: 16, marginRight: 2, border: '1px solid transparent', marginLeft: index === 0 ? '0' : '-8px'};
      avatars.push(<ImgAvatar key={accountId} color={color} imgName={image} style={style} altText={name} imgUrl={imageUrl}/>);
      index++;
    }
    return avatars;
  }
}

const mapDispatchToProps = {
  comment: ImageFlowActions.imageFlowCommentCreate,
  like: ImageFlowActions.imageFlowLike,
  seen: ImageFlowActions.imageFlowSeen,
  delete: ImageFlowActions.imageFlowDelete,
};

export default connect(null, mapDispatchToProps)(withStyles(imageFlowStyle)(ImageFlowPost));



// WEBPACK FOOTER //
// ./src/components/imageflow/ImageFlowPost.tsx